import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoginForm from './components/LoginForm';

import { login } from './authActions';
import { parseFormErrors } from '../shared/utils/form_errors';

class Login extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values) {
    return this.props.login(values)
      .catch(parseFormErrors);
  }

  render() {
    return (
      <div id="login">
        <div className="login-wrapper">
          <h1 className="title">Sneaker Crush Admin</h1>
          <LoginForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    )
  }
}

export default connect(null, { login })(Login);
